import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser, registerUser, CORPORATE_DOMAIN } from '../../redux/authSlice';
import logoGzi from '../../assets/gzi.jpg';
import './Login.css';

const Login = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isRegister, setIsRegister] = useState(false);

  const emailValid = !isRegister || email.trim().toLowerCase().endsWith(CORPORATE_DOMAIN);
  const canSubmit = emailValid && password.length >= 6 && !loading;

const handleSubmit = (e) => {
    e.preventDefault();
    if (!canSubmit) return;
            if (isRegister) {
      dispatch(registerUser({ email, password }));
    } else {
      dispatch(loginUser({ email, password }));
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '10px' }}>
          <img
            src={logoGzi}
            alt="ГЖИ"
            style={{ height: '50px', marginBottom: '8px' }}
          />
          <h2 style={{ margin: 0, color: '#1e3c72' }}>ГЖИ Санкт-Петербурга</h2>
        </div>

        <p style={{ textAlign: 'center', color: '#666', fontSize: '14px', marginBottom: '20px' }}>
          {isRegister ? 'Создайте учётную запись' : 'Вход в систему'}
        </p>

        <p style={{ textAlign: 'center', color: '#888', fontSize: '12px', marginBottom: '15px' }}>
          Доступ только для сотрудников с почтой <b>{CORPORATE_DOMAIN}</b>
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="ivanov@gzhi.gov.spb.ru"
            required
            style={{
              padding: '12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px',
              borderColor: email && !emailValid ? '#ff4d4f' : '#ddd',
            }}
          />
            {email && !emailValid && isRegister && (
            <p style={{ color: '#ff4d4f', fontSize: '12px', margin: 0 }}>
              Регистрация разрешена только с почтой {CORPORATE_DOMAIN}
            </p>
          )}

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Пароль (не менее 6 символов)"
            required
            minLength={6}
            style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
          />

          {error && (
            <p style={{ color: '#ff4d4f', fontSize: '13px', margin: 0, textAlign: 'center' }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={!canSubmit}
            style={{
              padding: '12px', borderRadius: '8px', border: 'none',
              background: canSubmit ? '#2a5298' : '#ccc',
              color: '#fff', fontWeight: 700, fontSize: '15px',
              cursor: canSubmit ? 'pointer' : 'not-allowed',
            }}
          >
            {loading ? 'Подождите...' : isRegister ? 'Зарегистрироваться' : 'Войти'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '15px', fontSize: '14px' }}>
          {isRegister ? 'Уже есть аккаунт? ' : 'Нет аккаунта? '}
          <button
            onClick={() => { setIsRegister(!isRegister); setEmail(''); setPassword(''); }}
            style={{ background: 'transparent', border: 'none', color: '#2a5298', cursor: 'pointer', fontWeight: 700, fontSize: '14px', textDecoration: 'underline' }}
          >
            {isRegister ? 'Войти' : 'Зарегистрироваться'}
          </button>
        </p>
      </div>
    </div>
  );
};

export default Login;